<template>
  <div class="log-interaction">
    <form v-if="!submitted" @submit="submit">
      <b-form-group
        label="Which students did you interact with?"
        :label-for="studentSelectId"
      >
        <multi-select
          :disabled="submitting"
          :class="[
            false === studentsValidation.getState(validate) ? 'error' : ''
          ]"
          :id="studentSelectId"
          v-model="formData.students"
          :options="studentList"
          :multiple="true"
          :close-on-select="true"
          :clear-on-select="false"
          :preserve-search="true"
          placeholder="student(s)"
          :custom-label="studentLabel"
          track-by="email"
          :preselect-first="false"
        >
        </multi-select>
        <b-form-invalid-feedback :state="studentsValidation.getState(validate)"
          >You must select at least one student to log an interaction
        </b-form-invalid-feedback>
      </b-form-group>
      <b-form-row>
        <b-col sm>
          <b-form-group
            label="Interaction Type"
            :label-for="interactionTypeSelectId"
          >
            <multi-select
              :disabled="submitting"
              :class="[
                false === typeValidation.getState(validate) ? 'error' : ''
              ]"
              :id="interactionTypeSelectId"
              v-model="formData.interactionTypeValue"
              :options="interactionTypes"
              :multiple="false"
              :close-on-select="true"
              :clear-on-select="false"
              :preserve-search="true"
              label="label"
              track-by="id"
              placeholder="interaction type"
              :preselect-first="false"
            >
            </multi-select>
            <b-form-invalid-feedback :state="typeValidation.getState(validate)"
              >You must select the type of interaction before the form can be
              submitted
            </b-form-invalid-feedback>
          </b-form-group>
        </b-col>
        <b-col sm>
          <b-form-group
            label="Topics Covered"
            :label-for="interactionTopicsSelectId"
          >
            <multi-select
              :disabled="submitting"
              :class="[
                false === topicsValidation.getState(validate) ? 'error' : ''
              ]"
              :id="interactionTopicsSelectId"
              v-model="formData.interactionTopicsValue"
              :options="interactionTopics"
              :multiple="true"
              :close-on-select="true"
              :clear-on-select="false"
              :preserve-search="true"
              label="label"
              track-by="id"
              placeholder="topics"
              :preselect-first="false"
            >
            </multi-select>
            <b-form-invalid-feedback
              :state="topicsValidation.getState(validate)"
              >You must select at least one topic discussed in this interaction
              before submitting it</b-form-invalid-feedback
            >
          </b-form-group>
        </b-col>
      </b-form-row>

      <b-form-row>
        <b-col sm>
          <b-form-group label="Date">
            <b-form-datepicker
              v-model="formData.startDate"
              :state="startDateValidation.getState(validate)"
            ></b-form-datepicker>
            <b-form-invalid-feedback
              :state="startDateValidation.getState(validate)"
              >You must enter the date interaction started
            </b-form-invalid-feedback>
          </b-form-group>
        </b-col>
        <b-col sm>
          <b-form-group label="Time">
            <b-form-row>
              <b-col sm>
                <b-form-select
                  v-model="formData.startTimeHr"
                  :state="startTimeHrValidation.getState(validate)"
                >
                  <b-form-select-option
                    v-for="n in 12"
                    :value="timePadding(n)"
                    :key="n"
                  >
                    {{ timePadding(n) }}
                  </b-form-select-option>
                </b-form-select>
                <b-form-invalid-feedback
                  :state="startTimeHrValidation.getState(validate)"
                  >You must enter the HH interaction started
                </b-form-invalid-feedback>
              </b-col>
              <b-col sm>
                <b-form-select
                  v-model="formData.startTimeMin"
                  :state="startTimeMinValidation.getState(validate)"
                >
                  <b-form-select-option
                    v-for="n in 12"
                    :value="timePadding((n - 1) * 5)"
                    :key="n"
                  >
                    {{ timePadding((n - 1) * 5) }}
                  </b-form-select-option>
                </b-form-select>
                <b-form-invalid-feedback
                  :state="startTimeMinValidation.getState(validate)"
                  >You must enter the MM interaction started
                </b-form-invalid-feedback>
              </b-col>
              <b-col sm>
                <b-form-select
                  v-model="formData.startTimeMeridiem"
                  :state="startTimeMeridiemValidation.getState(validate)"
                >
                  <option vale="am">AM</option>
                  <option vale="pm">PM</option>
                </b-form-select>
                <b-form-invalid-feedback
                  :state="startTimeMeridiemValidation.getState(validate)"
                  >You must enter the AM/PM interaction started
                </b-form-invalid-feedback>
              </b-col>
            </b-form-row>
          </b-form-group>
        </b-col>
      </b-form-row>
      <b-form-row>
        <b-col sm>
          <b-form-group label="Duration" v-if="!isMailOrChatSelected">
            <b-form-row>
              <b-col sm>
                <b-form-group description="Hour">
                  <b-form-select
                    v-model="formData.durationHr"
                    :state="durationValidation.getState(validate)"
                  >
                    <b-form-select-option
                      v-for="n in 12"
                      :value="n - 1"
                      :key="n"
                    >
                      {{ n - 1 }}
                    </b-form-select-option>
                  </b-form-select>
                </b-form-group>
              </b-col>
              <b-col sm>
                <b-form-group description="Min">
                  <b-form-select
                    v-model="formData.durationMin"
                    :state="durationValidation.getState(validate)"
                  >
                    <b-form-select-option
                      v-for="n in 12"
                      :value="(n - 1) * 5"
                      :key="n"
                    >
                      {{ (n - 1) * 5 }}
                    </b-form-select-option>
                  </b-form-select>
                </b-form-group>
              </b-col>
              <b-col cols="10"> </b-col>
            </b-form-row>
            <b-form-invalid-feedback
              :state="durationValidation.getState(validate)"
              >You must enter duration greater then 0
            </b-form-invalid-feedback>
          </b-form-group>
        </b-col>
      </b-form-row>
      <b-form-group label="Notes">
        <b-form-textarea
          :disabled="submitting"
          v-model="formData.notes"
          :state="notesValidation.getState(validate)"
        ></b-form-textarea>
        <b-form-invalid-feedback :state="notesValidation.getState(validate)"
          >You must enter some notes about the interaction
        </b-form-invalid-feedback>
      </b-form-group>
      <b-form-group
        :label="tagLabelValidation"
        :label-for="interactionTagSelectId"
      >
        <multi-select
          :disabled="submitting"
          :class="[false === tagValidation.getState(validate) ? 'error' : '']"
          :id="interactionTagSelectId"
          v-model="formData.interactionTagValue"
          :options="interactionTags"
          :multiple="false"
          :close-on-select="true"
          :clear-on-select="false"
          :preserve-search="true"
          label="label"
          track-by="id"
          placeholder="tags"
          :preselect-first="false"
        >
        </multi-select>
        <b-form-invalid-feedback :state="tagValidation.getState(validate)"
          >You must tag this interaction before submitting
          it</b-form-invalid-feedback
        >
      </b-form-group>
      <b-button
        variant="primary"
        class="red"
        type="submit"
        :disabled="submitting"
        ><b-spinner class="submitting-spinner" small v-if="submitting" />{{
          submitting ? "Submitting..." : "Submit"
        }}</b-button
      >
    </form>
    <div v-else>
      <p>Mentor / Student interaction submitted.</p>
    </div>
  </div>
</template>

<script>
import MentorApplicationApi from "../lib/MentorApplicationApi";
import MultiSelect from "vue-multiselect";
import {
  BFormGroup,
  BFormTextarea,
  BButton,
  BFormRow,
  BCol,
  BSpinner,
  BFormInvalidFeedback,
  BFormDatepicker,
  BFormSelect,
  BFormSelectOption
} from "bootstrap-vue";
import "vue-multiselect/dist/vue-multiselect.min.css";
import IdGeneratorFactory from "../lib/IdGeneratorFactory";
import {
  IsNotEmptyArray,
  IsNotEmptyObject,
  IsNotEmptyString,
  IsGreaterThanZero
} from "../lib/Validation";
let idGenerator = IdGeneratorFactory("send_message_{count}");

export default {
  name: "LogInteractionView",
  components: {
    MultiSelect,
    BFormGroup,
    BFormTextarea,
    BButton,
    BFormRow,
    BCol,
    BSpinner,
    BFormInvalidFeedback,
    BFormDatepicker,
    BFormSelect,
    BFormSelectOption
  },
  methods: {
    submit(e) {
      e.preventDefault();
      this.validate = true;
      if (this.hasValidationErrors) {
        return;
      }
      this.submitting = true;
      let that = this;
      this.api
        .logInteraction(
          this.user.id,
          this.formData.students.map(x => x.id), // transform to just the ID
          this.formatStartTime(),
          this.formatDuration(),
          this.formData.notes,
          this.formData.interactionTypeValue,
          this.formData.interactionTopicsValue,
          this.formData.interactionTagValue
        )
        .then(
          () => {
            that.submitting = false;
            that.submitted = true;
          },
          error => {
            that.submitting = false;
            alert(
              `Unable to log this interaction: ${
                null === error?.response?.data?.error
                  ? "unknown error"
                  : error.response.data.error
              }`
            );
          }
        )
        .catch(() => {
          that.submitting = false;
          return alert(`Unable to log this interaction due to unknown reasons`);
        });
    },
    studentLabel: option =>
      `${option.firstName} ${option.lastName} (${option.email})`,
    timePadding(e) {
      return e.toString().padStart(2, "0");
    },
    formatStartTime() {
      var date = new Date(this.formData.startDate).toLocaleDateString();
      var time = this.formData.startTimeHr + ":" + this.formData.startTimeMin;
      return new Date(date + " " + time).toISOString();
    },
    formatDuration() {
      if (this.isMailOrChatSelected) {
        return 0;
      }
      return (
        parseInt(this.formData.durationHr) * 60 * 60 +
        parseInt(this.formData.durationMin) * 60
      );
    }
  },
  computed: {
    tagLabelValidation() {
      return `How do you feel about the progress of ${
        this.formData.students.length > 1 ? "these students" : "this student"
      }?`;
    },
    studentsValidation() {
      return IsNotEmptyArray(this.formData.students);
    },
    startDateValidation() {
      return IsNotEmptyString(this.formData.startDate);
    },
    startTimeHrValidation() {
      return IsNotEmptyString(this.formData.startTimeHr);
    },
    startTimeMinValidation() {
      return IsNotEmptyString(this.formData.startTimeMin);
    },
    startTimeMeridiemValidation() {
      return IsNotEmptyString(this.formData.startTimeMeridiem);
    },
    durationValidation() {
      var duration =
        parseInt(this.formData.durationHr) +
        parseInt(this.formData.durationMin);
      return IsGreaterThanZero(duration);
    },
    durationMinValidation() {
      return IsGreaterThanZero(this.formData.durationMin);
    },
    notesValidation() {
      return IsNotEmptyString(this.formData.notes);
    },
    typeValidation() {
      return IsNotEmptyObject(this.formData.interactionTypeValue);
    },
    topicsValidation() {
      return IsNotEmptyArray(this.formData.interactionTopicsValue);
    },
    tagValidation() {
      return IsNotEmptyObject(this.formData.interactionTagValue);
    },
    hasValidationErrors() {
      var validationFields = [
        this.studentsValidation,
        this.startDateValidation,
        this.startTimeHrValidation,
        this.startTimeMinValidation,
        this.startTimeMeridiemValidation,
        this.notesValidation,
        this.typeValidation,
        this.topicsValidation,
        this.tagValidation
      ];

      if (!this.isMailOrChatSelected) {
        validationFields.push(this.durationValidation);
      }
      return validationFields.some(x => true !== x.isValid);
    },
    isMailOrChatSelected() {
      if (
        this.formData.interactionTypeValue.label === "Mail" ||
        this.formData.interactionTypeValue.label === "SMS / Chat"
      ) {
        return true;
      } else {
        return false;
      }
    }
  },
  props: {
    studentList: Array,
    user: Object,
    apiRootUrl: String,
    interactionTypes: Array,
    interactionTopics: Array,
    interactionTags: Array
  },
  data() {
    return {
      submitted: false,
      submitting: false,
      validate: false,
      studentSelectId: idGenerator(),
      interactionTypeSelectId: idGenerator(),
      interactionTopicsSelectId: idGenerator(),
      interactionTagSelectId: idGenerator(),
      api: new MentorApplicationApi(this.apiRootUrl),
      formData: {
        startDate: "", //new Date().toISOString(),
        startTime: new Date().toLocaleTimeString("en-US"),
        startTimeHr: "",
        startTimeMin: "",
        startTimeMeridiem: "",
        duration: "",
        durationHr: 0,
        durationMin: 0,
        notes: "",
        interactionTypeValue: {},
        interactionTopicsValue: [],
        interactionTagValue: {},
        students: []
      }
    };
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.submitting-spinner {
  margin-right: 0.5rem;
  vertical-align: middle;
}
</style>
